import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from '../Slider.module.css';
import useLocalizedPath from '../../../../hooks/useLocalizedPath';

const SlideContent = ({ title, description, category, isLoaded }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const localizedPath = useLocalizedPath();

  const handleProductClick = () => {
    navigate(localizedPath(`/products?category=${category}`));
  };

  const handleDemoClick = () => {
    navigate(localizedPath('/contact'));
  };

  return (
    <div className={`${styles.content} ${isLoaded ? styles.loaded : ''}`}>
      <div className={styles.textContent}>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.description}>{description}</p>
      </div>
      <div className={styles.buttonGroup}>
        <button 
          className={`${styles.button} ${styles.primaryButton}`}
          onClick={handleProductClick}
        >
          {t('home.slider.view_products')}
        </button>
        <button 
          className={`${styles.button} ${styles.secondaryButton}`}
          onClick={handleDemoClick}
        >
          {t('home.slider.request_demo')}
        </button>
      </div>
    </div>
  );
};

export default SlideContent; 